import { Exclude, Expose, Type } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';
import { IsBoolean, IsISO8601 } from 'class-validator';
import { JobLotRepairReportInterface } from '../interfaces/job-lot-repair-report.interface';

@Exclude()
export class JobLotRepairReportDto implements JobLotRepairReportInterface {
  @ApiProperty({
    type: 'string',
    title: 'id',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    type: 'string',
    title: 'jobId',
  })
  @Expose()
  jobId!: string;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'date-time',
    title: 'dateStart',
    description: 'dateStart',
  })
  @IsISO8601({ strict: true })
  @Expose()
  repairDate!: Date;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'date-time',
    title: 'createdAt',
    description: 'createdAt',
  })
  @IsISO8601({ strict: true })
  @Expose()
  createdAt!: Date;

  @ApiProperty({
    type: 'number',
    title: 'poTotal',
  })
  @Expose()
  poTotal!: number;

  @ApiProperty({
    type: 'string',
    title: 'text',
  })
  @Expose()
  text!: string;

  @ApiProperty({
    type: 'boolean',
    default: false,
    title: 'poReleased?',
    description: 'poReleased',
  })
  @IsBoolean()
  @Type(() => Boolean)
  @Expose()
  poReleased!: boolean;

  @ApiProperty({
    type: 'string',
    title: 'repairId',
  })
  @Expose()
  repairId!: string;

  @ApiProperty({
    type: 'string',
    title: 'repairType',
  })
  @Expose()
  repairType!: string;

  @ApiProperty({
    type: 'string',
    title: 'description',
  })
  @Expose()
  description!: string;

  @ApiProperty({
    type: 'boolean',
    default: false,
    title: 'hasPhotos?',
    description: 'hasPhotos',
  })
  @IsBoolean()
  @Type(() => Boolean)
  @Expose()
  hasPhotos!: boolean;

  @ApiProperty({
    type: 'string',
    title: 'repairType',
  })
  @Expose()
  userId!: string;
}
